module.exports = __webpack_public_path__ + "static/media/bg_02.6ad900c6.jpg";